import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  keyframes,
} from '@mui/material';
import { Autocomplete } from '@mui/material';
import servicio1 from '../../../services/servicio1';
import { useNavigate } from 'react-router-dom';
import Navbar from '../navcomun';

const tiposFutbol = ['Futbol 5', 'Futbol 6', 'Futbol 7', 'Futbol 8', 'Futbol 9', 'Futbol 10', 'Futbol 11'];

// Animación tipo "shake"
const shakeKeyframes = keyframes`
  10%, 90% { transform: translateX(-2px); }
  20%, 80% { transform: translateX(4px); }
  30%, 50%, 70% { transform: translateX(-8px); }
  40%, 60% { transform: translateX(8px); }
`;
const nivelesFutbol = ['Principiante', 'Amateur', 'Competitivo', 'Jugadores de liga'];
const tiposGenero = ['Masculino', 'Femenino', 'Mixto'];
const seBusca = ['Jugador/Jugadores', 'Rival (equipo completo)'];
export default function CrearPartido() {
  const navigate = useNavigate();
  const [userId, setUserId] = useState(null);
  const [usarCanchaExistente, setUsarCanchaExistente] = useState(true);
  const [canchaSeleccionada, setCanchaSeleccionada] = useState(null);
  const [canchasExistentes, setCanchasExistentes] = useState([]);
  const [nuevaCancha, setNuevaCancha] = useState({ nombre: '', barrio: '', ciudad: '' });
  const [genero, setGenero] = useState('');
  const [busqueda, setBusqueda] = useState('');

  const [fecha, setFecha] = useState('');
  const [hora, setHora] = useState('');
  const [tipo, setTipo] = useState('');
  const [cupo, setCupo] = useState('');
  const [nivel, setNivel] = useState('');
  const [errores, setErrores] = useState({});

  useEffect(() => {
    const userJSON = window.localStorage.getItem('loggedNoteAppUser');
    if (userJSON) {
      const user = JSON.parse(userJSON);
      setUserId(user.id);
    } else {
      navigate('/falta1/login');
    }

    const fetchCanchas = async () => {
      try {
        const data = await servicio1.traercanchas();
        setCanchasExistentes(data);
      } catch (error) {
        console.error('Error al traer canchas:', error);
      }
    };

    fetchCanchas();
  }, [navigate]);

  const validarCampos = () => {
    const nuevoErrores = {};

    if (usarCanchaExistente) {
      if (!canchaSeleccionada) nuevoErrores.canchaSeleccionada = true;
    } else {
      if (!nuevaCancha.nombre) nuevoErrores.nombre = true;
      if (!nuevaCancha.barrio) nuevoErrores.barrio = true;
      if (!nuevaCancha.ciudad) nuevoErrores.ciudad = true;
    }

    if (!fecha) nuevoErrores.fecha = true;
    if (!hora) nuevoErrores.hora = true;
    if (!tipo) nuevoErrores.tipo = true;
    if (!cupo) nuevoErrores.cupo = true;

    setErrores(nuevoErrores);
    return Object.keys(nuevoErrores).length === 0;
  };

  const handleSubmit = async () => {
    if (!validarCampos()) return;

    const datos = {
      usuario_id: userId,
      cancha: usarCanchaExistente ? canchaSeleccionada?.id || null : null,
      nombre_cancha: usarCanchaExistente ? '' : nuevaCancha.nombre,
      barrio: usarCanchaExistente ? '' : nuevaCancha.barrio,
      ciudad: usarCanchaExistente ? '' : nuevaCancha.ciudad,
      fecha,
      hora,
      tipo,
      nivel,
      genero,
      busqueda,
      cupo: parseInt(cupo, 10),
    };

    try {
      await servicio1.crearpartido(datos);
      alert('Partido creado exitosamente');
      navigate('/falta1/principal');
    } catch (error) {
      console.error('Error al crear el partido:', error);
      alert('Error al crear el partido');
    }
  };

  const shakeStyle = (campo) =>
    errores[campo]
      ? {
        animation: `${shakeKeyframes} 0.4s ease`,
        borderColor: 'red',
      }
      : {};

  return (
    <Box>
      <Navbar />
      <Box sx={{ maxWidth: 600, margin: 'auto', mt: 4, p: 3, boxShadow: 3, borderRadius: 2 }}>
        <Typography variant="h5" gutterBottom>Crear nuevo partido</Typography>

        <FormControlLabel
          control={
            <Checkbox
              checked={!usarCanchaExistente}
              onChange={() => setUsarCanchaExistente(!usarCanchaExistente)}
            />
          }
          label="Registrar una nueva cancha"
        />

        {usarCanchaExistente ? (
          <Autocomplete
            options={canchasExistentes}
            getOptionLabel={(option) => typeof option === 'string' ? option : option.nombre}
            value={canchaSeleccionada}
            onChange={(event, newValue) => setCanchaSeleccionada(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Seleccionar cancha"
                fullWidth
                error={!!errores.canchaSeleccionada}
                sx={shakeStyle('canchaSeleccionada')}
              />
            )}
            sx={{ mt: 2 }}
          />
        ) : (
          <Grid container spacing={2} mt={1}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nombre de la cancha"
                value={nuevaCancha.nombre}
                onChange={(e) => setNuevaCancha({ ...nuevaCancha, nombre: e.target.value })}
                error={!!errores.nombre}
                sx={shakeStyle('nombre')}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Barrio"
                value={nuevaCancha.barrio}
                onChange={(e) => setNuevaCancha({ ...nuevaCancha, barrio: e.target.value })}
                error={!!errores.barrio}
                sx={shakeStyle('barrio')}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Ciudad"
                value={nuevaCancha.ciudad}
                onChange={(e) => setNuevaCancha({ ...nuevaCancha, ciudad: e.target.value })}
                error={!!errores.ciudad}
                sx={shakeStyle('ciudad')}
              />
            </Grid>
          </Grid>
        )}
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Tipo de futbol</InputLabel>
          <Select
            value={genero}
            onChange={(e) => setGenero(e.target.value)}
            label="Tipo de futbol"
          >
            {tiposGenero.map((opcion, idx) => (
              <MenuItem key={idx} value={opcion}>{opcion}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Se busca</InputLabel>
          <Select
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            label="Se busca"
          >
            {seBusca.map((opcion, idx) => (
              <MenuItem key={idx} value={opcion}>{opcion}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          fullWidth
          label="Fecha"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
          error={!!errores.fecha}
          sx={{ mt: 2, ...shakeStyle('fecha') }}
        />

        <TextField
          fullWidth
          label="Hora"
          type="time"
          InputLabelProps={{ shrink: true }}
          value={hora}
          onChange={(e) => setHora(e.target.value)}
          error={!!errores.hora}
          sx={{ mt: 2, ...shakeStyle('hora') }}
        />

        <FormControl fullWidth sx={{ mt: 2, ...shakeStyle('tipo') }} error={!!errores.tipo}>
          <InputLabel>Tipo de partido</InputLabel>
          <Select
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
            label="Tipo de partido"
          >
            {tiposFutbol.map((tipo, idx) => (
              <MenuItem key={idx} value={tipo}>{tipo}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          fullWidth
          label="Cupo de jugadores"
          type="number"
          inputProps={{ min: 1 }}
          value={cupo}
          onChange={(e) => setCupo(e.target.value)}
          error={!!errores.cupo}
          sx={{ mt: 2, ...shakeStyle('cupo') }}
        />

        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel>Competitividad</InputLabel>
          <Select
            value={nivel}
            onChange={(e) => setNivel(e.target.value)}
            label="Competitividad"
          >
            {nivelesFutbol.map((opcion, idx) => (
              <MenuItem key={idx} value={opcion}>{opcion}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box textAlign="center" mt={3}>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Crear partido
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
